import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { failAlert, successAlert } from "../../common/alert";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../redux/action/confirm";
import { isLoaded, isLoading } from "../../redux/action/loading";
import Layout from "../layout/Layout";
import GroupEventUI from "./GroupEvent";
import { EventPagesAPI } from "../../api/apis";
import PostCode from "../../common/postcode";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { GPTypeOneSchema, GPTypeTwoSchema } from "../../common/validation";
import { getTimeStamp } from "../../common/util/getDate";
import { Spinner } from "react-bootstrap";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const GroupEventLayout = (props) => {
  const {
    isLoading,
    isLoaded,
    openConfirmModal,
    modifyConfirmModal,
    closeConfirmModal,
    parent,
    sub,
    subChild,
    code,
    userInfo,
  } = props;
  const router = useRouter();
  const [postCodeOpen, setPostCodeOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [scroll, setScroll] = useState(false);
  const [inputData, setInputData] = useState({
    check: false,
  });
  const typeOneOptions = {
    resolver: yupResolver(
      GPTypeOneSchema({
        min: detailData?.min,
        rounding: detailData?.rounding,
        max: detailData?.max,
      })
    ),
    mode: "onChange",
  };
  const typeTwoOptions = {
    resolver: yupResolver(GPTypeTwoSchema),
    mode: "onChange",
  };

  const typeOneUseForm = useForm(typeOneOptions);
  const typeTwoUseForm = useForm(typeTwoOptions);

  const fetchUserInfo = async () => {
    if (userInfo) {
      const member = userInfo?.Member;
      const address = userInfo?.Address?.data.find((el) => el.basic === "Y");
      const eduDefault = {
        cnt: 1,
      };
      const groupDefault = {
        cnt: 500,
        memo: "",
        editYn: "",
      };
      const userInfoDefault = {
        name: member?.name || "",
        phone: member?.phone || "",
        company: userInfo?.Company?.Data?.name || "",
        email: member?.email || "",
        ...address,
      };

      let tempObj = {};

      if (router.pathname.includes("edu")) {
        tempObj = { ...eduDefault, ...userInfoDefault };
      }
      if (router.pathname.includes("group-purchase")) {
        tempObj = { ...groupDefault, ...userInfoDefault };
        typeOneUseForm.reset({
          ...typeOneUseForm.getValues(),
          ...groupDefault,
          ...userInfoDefault,
        });
      }
      setInputData({
        ...inputData,
        ...tempObj,
      });
    } else {
      return;
    }
  };

  const handleInputData = (e, key) => {
    if (key === "check") {
      setInputData({ ...inputData, [key]: e.target.checked });
      return;
    }
    setInputData({ ...inputData, [key]: e.target.value });
  };

  const fetchDetail = async (code) => {
    isLoading();
    const body = {
      modes: "ViewSet",
      code: code,
    };
    const res = await EventPagesAPI(body);

    if (res?.Code === "0000") {
      setDetailData({ ...res.Data?.Row, info: res?.Data?.Info });
    } else {
      failAlert(res.Data?.Msg || "조회 실패");
    }
    isLoaded();
  };

  const confirmInsert = async (data) => {
    if (!userInfo) {
      failAlert("로그인 후 이용가능한 서비스 입니다.");
      router.push("/login");
      return;
    }
    isLoading();
    const body = {
      modes: "InsertSet",
      code: code,
      ...data,
    };
    const res = await EventPagesAPI(body);
    if (res.Code === "0000") {
      successAlert(res.Data?.Msg || "등록되었습니다.");
      if (detailData.type === "TYPE1") {
        router.push("/mypage/group-purchase/");
      }
    } else if (res.Code === "8888") {
    } else {
      failAlert(res.Data?.Msg || "등록 실패");
    }
    fetchDetail(code);
    isLoaded();
  };

  const cancelInsert = async (id) => {
    const content = {
      title: "취소하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onClose: () => {},
      onAction: async () => {
        isLoading();
        const body = {
          modes: "CancelSet",
          id: id,
        };
        const res = await EventPagesAPI(body);
        if (res.Code === "0000") {
          successAlert(res.Data?.Msg || "취소 완료");
          fetchDetail(code);
        } else {
          failAlert(res.Data?.Msg || "취소 실패");
          fetchDetail(code);
        }
        closeConfirmModal();
        isLoaded();
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  // 우편번호 검색
  const onClickHandleModal = () => {
    setPostCodeOpen((prev) => !prev);
  };
  const onCompletePostCode = (postcode) => {
    setInputData({
      ...inputData,
      doro_addr:
        postcode.roadAddress !== ""
          ? postcode.roadAddress
          : postcode.autoRoadAddress,
      base_addr:
        postcode.jibunAddress !== ""
          ? postcode.jibunAddress
          : postcode.autoJibunAddress,
      zipcode: postcode.zonecode,
    });
    if (detailData?.type === "TYPE1") {
      typeOneUseForm.reset({
        ...typeOneUseForm.getValues(),
        doro_addr:
          postcode.roadAddress !== ""
            ? postcode.roadAddress
            : postcode.autoRoadAddress,
        base_addr:
          postcode.jibunAddress !== ""
            ? postcode.jibunAddress
            : postcode.autoJibunAddress,
        zipcode: postcode.zonecode,
      });
    }
    setPostCodeOpen(false);
  };

  // check open
  const checkOpen = () => {
    if (!detailData?.sdate) {
      return "loading";
    }
    if (getTimeStamp() < new Date(detailData?.sdate).getTime()) {
      return "before";
    } else if (getTimeStamp() > new Date(detailData?.edate).getTime()) {
      return "after";
    } else {
      return "proceeding";
    }
  };

  const [eventOpen, setEventOpen] = useState(checkOpen());

  useEffect(() => {
    if (detailData?.sdate) {
      const timer = setInterval(() => {
        setEventOpen(checkOpen());
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [detailData]);

  useEffect(() => {
    if (!router.isReady) return;
    if (code === null) setEventOpen("none");
    if (userInfo) fetchUserInfo();
    fetchDetail(code);
  }, [router.isReady, userInfo, code]);

  useEffect(() => {
    const scrollControl = () => {
      const scrollCheck = window.scrollY >= 100;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    };

    document.addEventListener("scroll", scrollControl);

    return () => {
      document.removeEventListener("scroll", scrollControl);
    };
  });

  return (
    <>
      <Layout
        parent={parent || "홈"}
        sub={"공동구매"}
        pageTitle={SeoMeta.groupPurchase.title}
        pageDesc={SeoMeta.groupPurchase.description}
        pageKeyword={SeoMeta.groupPurchase.keywords}
      >
        {code !== undefined ? (
          <GroupEventUI
            detailData={detailData}
            scroll={scroll}
            subChild={subChild}
            inputData={inputData}
            setInputData={setInputData}
            handleInputData={handleInputData}
            confirmInsert={confirmInsert}
            userInfo={userInfo}
            cancelInsert={cancelInsert}
            onClickHandleModal={onClickHandleModal}
            typeOneUseForm={typeOneUseForm}
            typeTwoUseForm={typeTwoUseForm}
            eventOpen={eventOpen}
          />
        ) : (
          <div style={{ height: "350px" }} />
        )}
        {postCodeOpen && (
          <PostCode
            onClickHandleModal={onClickHandleModal}
            onCompletePostCode={onCompletePostCode}
          />
        )}
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});

const mapDispatchToProps = {
  isLoading,
  isLoaded,
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupEventLayout);
